import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NavigationLinks({
  location,
  isAboutMenuOpen,
  toggleAboutMenu,
  closeMenus,
  isMobile = false,
}) {
  const { t } = useTranslation();

  const labels = {
    aboutUs: t("navbar.aboutUs"),
    dojoGallery: t("navbar.dojoGallery"),
    prices: t("navbar.prices"),
    schedule: t("navbar.schedule"),
    contact: t("navbar.contact"),
    regulations: t("navbar.regulations"),
  };

  const isActive = (path) => location.pathname === path;
  const isInfoPageActive = ["/aboutUs", "/dojo", "/prices", "/regulations"].some(isActive);

  const navLinkClass = (path) =>
    `nav-link roboto-light px-2 ${isActive(path) ? "link-gold" : "link-light"}`;

  const dropdownToggleClass = `nav-link dropdown-toggle roboto-light px-2 ${
    isInfoPageActive ? "link-gold" : "link-light"
  }`;

  if (isMobile) {
    return (
      <ul className="nav-links-list is-mobile">
        <li className="nav-item px-2">
          <Link className={navLinkClass("/aboutUs")} to="/aboutUs" onClick={closeMenus}>
            {labels.aboutUs}
          </Link>
        </li>

        <li className="nav-item px-2">
          <Link className={navLinkClass("/dojo")} to="/dojo" onClick={closeMenus}>
            {labels.dojoGallery}
          </Link>
        </li>

        <li className="nav-item px-2">
          <Link className={navLinkClass("/prices")} to="/prices" onClick={closeMenus}>
            {labels.prices}
          </Link>
        </li>

        <li className="nav-item px-2">
          <Link
            className={navLinkClass("/regulations")}
            to="/regulations"
            onClick={closeMenus}
          >
            {labels.regulations}
          </Link>
        </li>

        <li className="nav-item px-2">
          <Link className={navLinkClass("/schedule")} to="/schedule" onClick={closeMenus}>
            {labels.schedule}
          </Link>
        </li>

        <li className="nav-item px-2">
          <Link className={navLinkClass("/contact")} to="/contact" onClick={closeMenus}>
            {labels.contact}
          </Link>
        </li>
      </ul>
    );
  }

  return (
    <ul className="nav-links-list">
      {/* Dropdown */}
      <li className={`nav-item dropdown px-2 nav-dropdown${isAboutMenuOpen ? " is-open" : ""}`}>
        <button
          type="button"
          className={dropdownToggleClass}
          id="aboutDropdown"
          aria-expanded={isAboutMenuOpen}
          aria-controls="aboutDropdownMenu"
          onClick={toggleAboutMenu}
        >
          {labels.aboutUs}
        </button>

        <ul
          id="aboutDropdownMenu"
          className={`dropdown-menu shadow-lg border-0 mt-2${isAboutMenuOpen ? " show" : ""}`}
          aria-labelledby="aboutDropdown"
        >
          <li>
            <Link
              className={`dropdown-item ${isActive("/aboutUs") ? "active" : ""}`}
              to="/aboutUs"
              onClick={closeMenus}
            >
              {labels.aboutUs}
            </Link>
          </li>
          <li>
            <Link
              className={`dropdown-item ${isActive("/dojo") ? "active" : ""}`}
              to="/dojo"
              onClick={closeMenus}
            >
              {labels.dojoGallery}
            </Link>
          </li>
          <li>
            <Link
              className={`dropdown-item ${isActive("/prices") ? "active" : ""}`}
              to="/prices"
              onClick={closeMenus}
            >
              {labels.prices}
            </Link>
          </li>
          <li>
            <Link
              className={`dropdown-item ${isActive("/regulations") ? "active" : ""}`}
              to="/regulations"
              onClick={closeMenus}
            >
              {labels.regulations}
            </Link>
          </li>
        </ul>
      </li>

      {/* Regular nav items */}
      <li className="nav-item px-2">
        <Link className={navLinkClass("/schedule")} to="/schedule" onClick={closeMenus}>
          {labels.schedule}
        </Link>
      </li>

      <li className="nav-item px-2">
        <Link className={navLinkClass("/contact")} to="/contact" onClick={closeMenus}>
          {labels.contact}
        </Link>
      </li>
    </ul>
  );
}

export default NavigationLinks;
